import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'

const __default__ = { name: 'DcCosLbuSalesClueEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const initForm: LbuSalesClueEditParams.RootObject = reactive({
  contact: {},
  business: { saleInfo: [{}], demandInfo: [{}], erpInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<LbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.visitAddress == null || res.data.visitAddress?.length === 0) {
      res.data.visitAddress = [{}]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(DetailForm, {
            ref: "detailFormRef",
            type: "edit",
            isEdit: "",
            value: dataForm,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
            resetValue: initForm
          }, null, 8, ["value", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})